import gql from 'graphql-tag';

export const departmentFragments = gql`
  fragment departmentFragments on Department {
    id
    code
    name
    unit {
      id
    }
  }
`;

export const ALL_DEPARTMENTS = gql`
  query currentUnitDepartments {
    currentUnit {
      id
      departments {
        ...departmentFragments
      }
    }
  },
  ${departmentFragments}
`;
